import { useTranslation } from 'react-i18next'

import useProductReviewCreate from '@entities/Review/hooks/useProductReviewCreate'

import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'

import { ReviewProductCreateProps } from './create'

interface OpenReviewCreateProps extends ReviewProductCreateProps {
  className?: string;
}

export default function OpenReviewCreate (props: OpenReviewCreateProps) {
  const { className, ...rest } = props
  const { t: tc } = useTranslation('common')
  const { openProductReviewModal } = useProductReviewCreate(rest)
  return (
    <Button className={cn(className)} onClick={openProductReviewModal}>
      {tc('review.leave')}
    </Button>
  )
}
